import { FormGroup, Input, Label } from "reactstrap";
import { SellingProductCheckboxProp } from "../../../../Type/DashboardType";

export const SellingProductCheckbox = ({ id }: SellingProductCheckboxProp) => {
  return (
    <td>
      <FormGroup check>
        <Input type="checkbox" id={`flexCheckDefault${id}`} defaultValue="" />
        <Label check htmlFor={`flexCheckDefault${id}`}></Label>
      </FormGroup>
    </td>
  );
};
